// extracted by css-extract-rspack-plugin
var _1 = "_8G-xate3R-b-zxgr4kOIVA--";
var _2 = "_46SDI4oBv1FJ9MP-lJBLjQ--";
var _3 = "ob18su2rTVzKBkSqppozpg--";
var _4 = "JhYYn0IJ31ORwwPuXbxKFw--";
var _5 = "G8nsYJ9HKHF0dRzO-WPVHg--";
var _6 = "O6K7OAoq-oSIZf5GIguJWw--";
var _7 = "_9FG6bBC-Os4A5Md-XeXj0Q--";
var _8 = "_8-rCHG--YtW6bNsAMajmUA--";
var _9 = "iVGm1-qksw3l-xU4fGQARA--";
var _a = "XZSY6xr7qpMLK4T8hKLjTA--";
export { _1 as "content", _2 as "contentFooter", _3 as "epilogue", _4 as "header", _5 as "illustration", _6 as "indicator", _7 as "preamble", _8 as "signUp", _9 as "signUpWide", _a as "smallerMarginHeader" }
